module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/vendor.component.css
// module id = ./src/app/vendor/vendor.component.css
// module chunks = main